import vue from 'vue';
import VueI18n from 'vue-i18n';

vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'es',
    messages: {
        en: {
            btnInformation: 'About',
            btnContact: 'Contact',
            btnClients: 'Work',
            btnProjects: 'Projects',
            btnTerms: 'Terms & conditions',
            btnPrivacyPolicy: 'Privacy policy',
            btnPhotography: 'Photography',
            btnBranding: 'Branding',
            // contact
            name: 'Name',
            company: 'Company',
            email: 'Email',
            phone: 'Phone',
            city: 'City',
            country: 'Country',
            service: 'Service',
            message: 'Message',
            contactMethod: 'Preferred Contact Method',
            btnSend: 'Send',
            firstName: 'First Name',
            age: 'Age',
            nationality: 'Nationality',
            currentCity: 'Current City',
            applyTo: 'Applying for',
            portfolio: 'Portfolio URL starting with http://',
            // titles forms
            titleContact: 'Contact us.',
            titleWorkWithUs: 'Work with us.',
            //notification send
            notificationSend: 'Your message has been sent.',
            validationText: 'Required field'
        },
        es: {
            btnInformation: 'Nosotros',
            btnContact: 'Contacto',
            btnClients: 'Clientes',
            btnProjects: 'Proyectos',
            btnTerms: 'Términos y condiciones',
            btnPrivacyPolicy: 'Aviso de privacidad',
            btnPhotography: 'Fotografía',
            btnBranding: 'Marca',
            // contact
            name: 'Nombre',
            company: 'Compañía',
            email: 'Correo electrónico',
            phone: 'Teléfono',
            city: 'Ciudad',
            country: 'País',
            service: 'Servicio',
            message: 'Mensaje',
            contactMethod: 'Método de contacto preferido',
            btnSend: 'Enviar',
            firstName: 'Apellido',
            age: 'Edad',
            nationality: 'Nacionalidad',
            currentCity: 'Ciudad Actual',
            applyTo: 'Aplicando para',
            portfolio: 'URL del portafolio comiena con http://',
            // titles forms
            titleContact: 'Contáctanos.',
            titleWorkWithUs: 'Trabaja con nosotros.',
            notificationSend: 'Tu mensaje ha sido enviado.',
            validationText: 'Campo requerido'
        }
    }
})